/**
 * Rachel's Hair Loft — swiper-slider.js
 * Custom <swiper-slider> web component wrapping Swiper.js
 * Used by: featured-products, featured-collections sections
 */

// Dynamically load Swiper from CDN if not already present
function loadSwiper () {
  return new Promise((resolve) => {
    if (window.Swiper) return resolve()

    // CSS
    if (!document.querySelector('#swiper-css')) {
      const link = document.createElement('link')
      link.id   = 'swiper-css'
      link.rel  = 'stylesheet'
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css'
      document.head.appendChild(link)
    }

    // JS
    const script = document.createElement('script')
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js'
    script.onload = resolve
    document.head.appendChild(script)
  })
}

class SwiperSlider extends HTMLElement {
  async connectedCallback () {
    await loadSwiper()
    this.initSwiper()

    // Re-init on Shopify theme editor section reload
    document.addEventListener('shopify:section:load', (e) => {
      if (e.target.contains(this)) this.initSwiper()
    })
  }

  initSwiper () {
    const el = this.querySelector('.swiper')
    if (!el || el._swiperInstance) return

    // Read config from data attributes
    const speed      = parseInt(this.dataset.sliderSpeed)      || 300
    const autoplayMs = parseInt(this.dataset.sliderAutoplay)   || 0
    const mobile     = parseInt(this.dataset.breakpointMobile) || 1
    const tablet     = parseInt(this.dataset.breakpointTablet) || 2
    const desktop    = parseInt(this.dataset.breakpointDesktop)|| 4

    const showNav        = this.dataset.sliderNavigation    !== 'false'
    const showPagination = this.dataset.sliderPagination    !== 'false'
    const paginationType = this.dataset.sliderPaginationType || 'bullets'
    const showScrollbar  = this.dataset.sliderScrollbar     !== 'false'
    const partialMobile  = this.dataset.sliderPartialSlidesMobile !== 'false'

    const config = {
      speed,
      grabCursor: true,
      slidesPerView: partialMobile ? mobile + 0.15 : mobile,
      spaceBetween: 0,

      breakpoints: {
        600: {
          slidesPerView: tablet,
          spaceBetween: 0
        },
        1200: {
          slidesPerView: desktop,
          spaceBetween: 0
        }
      },

      navigation: showNav ? {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      } : false,

      pagination: showPagination ? {
        el: this.querySelector('.swiper-pagination'),
        type: paginationType,
        clickable: true
      } : false,

      scrollbar: showScrollbar ? {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      } : false,

      autoplay: autoplayMs > 0 ? {
        delay: autoplayMs * 1000,
        disableOnInteraction: false
      } : false,

      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide'
      }
    }

    const instance = new Swiper(el, config)
    el._swiperInstance = instance
  }
}

customElements.define('swiper-slider', SwiperSlider)
